const prefix = 'cvf-admin/sessions/';

// Active Sessions
export const GET_ACTIVE_SESSIONS = `${prefix}GET_ACTIVE_SESSIONS`;
export const GET_ACTIVE_SESSIONS_SUCCESS = `${prefix}GET_ACTIVE_SESSIONS_SUCCESS`;
export const GET_ACTIVE_SESSIONS_ERROR = `${prefix}GET_ACTIVE_SESSIONS_ERROR`;

// Historical Sessions
export const GET_HISTORICAL_SESSIONS = `${prefix}GET_HISTORICAL_SESSIONS`;
export const GET_HISTORICAL_SESSIONS_SUCCESS = `${prefix}GET_HISTORICAL_SESSIONS_SUCCESS`;
export const GET_HISTORICAL_SESSIONS_ERROR = `${prefix}GET_HISTORICAL_SESSIONS_ERROR`;

// End active CVF Session
export const END_SESSION = `${prefix}END_SESSION`;
export const END_SESSION_SUCCESS = `${prefix}END_SESSION_SUCCESS`;
export const END_SESSION_ERROR = `${prefix}END_SESSION_ERROR`;
